import { AppModule } from './app/app.module';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { register as registerSwiperElements } from 'swiper/element/bundle';

/**
 * Client-side application entry point for Angular Universal SSR.
 * 
 * **SSR Execution Context:**
 * - Runs ONLY in the browser environment (client-side)
 * - Never executed during server-side rendering
 * - Responsible for hydrating the server-rendered application
 * 
 * **Client-Side Bootstrap Process:**
 * 1. Browser loads and executes this file after receiving server-rendered HTML
 * 2. platformBrowserDynamic() creates the browser platform
 * 3. AppModule is bootstrapped with performance optimizations
 * 4. Angular hydration process begins, preserving server-rendered DOM
 * 5. Event listeners and interactivity are attached to existing elements
 * 
 * **Performance Optimizations:**
 * - ngZoneEventCoalescing: Batches multiple events in the same task for better performance
 * - Reduces the number of change detection cycles triggered by events
 * - Improves application responsiveness and reduces CPU usage
 * 
 * **Third-Party Integrations:**
 * - Swiper elements are registered for carousel/slider functionality
 * - Custom elements are made available globally for use in components
 * 
 * **Error Handling:**
 * - Bootstrap errors are caught and logged to console
 * - Prevents silent failures during application initialization
 * 
 * @file main.ts
 * @description Client-side entry point that bootstraps the Angular application with hydration support
 */

platformBrowserDynamic()
    .bootstrapModule(AppModule, {
        ngZoneEventCoalescing: true,
    })
    .catch((err) => console.error(err));

/**
 * Registers Swiper custom elements for use throughout the application.
 * 
 * **SSR Compatibility:**
 * - Safe to call in browser environment
 * - Swiper elements are registered globally after Angular bootstrap
 * - Does not interfere with server-side rendering process
 * 
 * **Usage:**
 * - Enables <swiper-container> and <swiper-slide> custom elements
 * - Provides carousel/slider functionality across components
 */
registerSwiperElements();
